import * as dialog from 'plugins/dialog';

import BaseModal from '@/legacy/modals/BaseModal';

declareModules({
  'modals/genericInfoModal.html': () => import('@/legacy/modals/genericInfoModal.html'),
});

interface GenericInfoButton {
  title: string;
  cssClass: string;
}
interface ViewModelParams {
  message: string;
  title: string;
  continueButtonLabel?: string;
  cancelButtonLabel?: string;
  /**
   * If set the Yes/No buttons locations will be swapped and "No" option will have primary color
   * */
  swapButtons?: boolean;
}

class StyledModal extends BaseModal {
  view = 'modals/genericInfoModal';

  public params: ViewModelParams;

  constructor(params: ViewModelParams) {
    super();
    params.continueButtonLabel = params.continueButtonLabel ? params.continueButtonLabel : 'Yes';
    params.cancelButtonLabel = params.cancelButtonLabel ? params.cancelButtonLabel : 'No';
    params.swapButtons = !!params.swapButtons;

    this.params = params;
  }

  public close(): void {
    return dialog.close(this, 'Yes');
  }

  public cancel(): void {
    return dialog.close(this, 'No');
  }

  public static show(params: ViewModelParams): JQueryPromise<any> {
    return dialog.show(new StyledModal(params));
  }
}

export default StyledModal;
